export const HOME = '/';
export const PRIVACY_POLICY = '/privacy';
